import React from "react";
import styled from "styled-components";

export const VDivider = styled.div`
  width: 0;
  height: ${props => props.height || "100%"};
  border: 1px solid ${props => props.color || props.theme.colors.primary.white};
  margin: ${props => props.margin || "0"};
  padding: ${props => props.padding || "0"};
`;

export const Box = styled.div`
  ${({ display }) => display && `display: ${display};`}
  ${({ justifyContent }) =>
    justifyContent && `justify-content: ${justifyContent};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop};`}
  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`}
  ${({ marginRight }) => marginRight && `margin-right: ${marginRight};`}
  ${({ marginLeft }) => marginLeft && `margin-left: ${marginLeft};`}
  ${({ padding }) => padding && `padding: ${padding};`}
  ${({ paddingTop }) => paddingTop && `padding-top: ${paddingTop};`}
  ${({ paddingLeft }) => paddingLeft && `padding-left: ${paddingLeft};`}
  ${({ paddingRight }) => paddingRight && `padding-right: ${paddingRight};`}
  ${({ width }) => width && `width: ${width};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${({ flexGrow }) => flexGrow && `flex-grow: ${flexGrow};`}
  ${({ background }) => background && `background: ${background};`}
  ${({ border }) => border && `border: ${border};`}
  ${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius};`}
  ${({ gap }) => gap && `gap: ${gap}`}
`;

export const FlexBox = props => <Box display="flex" {...props} />;

export const Input = styled.input`
  background: ${props =>
    props.disabled ? props.theme.colors.primary.grey : "transparent"};
  border-width: ${props =>
    props.variant === "outlined" ? "1px" : "0 0 1px 0"};
  border-style: solid;
  border-color: ${props => {
    if (props.disabled) return props.theme.colors.primary.grey;
    if (props.variant === "outlined") {
      if (props.darkMode) return props.theme.colors.primary.dark;
      return props.theme.colors.primary.dimGrey;
    }
    if (props.darkMode) return props.theme.colors.primary.dark;
    return props.theme.colors.primary.white;
  }};

  border-radius: ${props => (props.shape === "round" ? "32px" : "0")};

  box-sizing: border-box;
  padding: ${props =>
    props.variant === "outlined" ? "1.6rem 2.5rem" : "0.4rem 0rem"};

  font-size: 1.6rem;
  font-weight: ${props => props.theme.fontWeight.regular};
  line-height: 120%;
  color: ${props =>
    props.color ||
    (props.darkMode || props.variant === "outlined"
      ? props.theme.colors.primary.dark
      : props.theme.colors.primary.white)};

  width: ${props => props.width || "100%"};

  &::placeholder {
    color: ${props =>
      props.darkMode || props.variant === "outlined"
        ? props.theme.colors.primary.dimGrey
        : props.theme.colors.primary.white};
  }

  &:focus {
    outline: none !important;
  }

  &:-internal-autofill-selected {
    background-color: transparent !important;
  }

  ${props => {
    if (props.disabled) return `cursor: text;`;
  }}
`;

export const TextArea = styled.textarea`
  background: ${props =>
    props.disabled ? props.theme.colors.primary.grey : "transparent"};
  border: 0;
  border-bottom: 1px solid
    ${props =>
      props.disabled
        ? props.theme.colors.primary.grey
        : props.darkMode
        ? props.theme.colors.primary.dark
        : props.theme.colors.primary.white};
  box-sizing: border-box;
  padding: 0.4rem 0rem;

  font-size: 1.6rem;
  font-weight: ${props => props.theme.fontWeight.regular};
  line-height: 120%;
  color: ${props =>
    props.color || props.darkMode
      ? props.theme.colors.primary.dark
      : props.theme.colors.primary.white};

  width: 100%;

  &::placeholder {
    color: ${props =>
      props.darkMode
        ? props.theme.colors.primary.dark
        : props.theme.colors.primary.white};
  }

  &:focus {
    outline: none !important;
  }

  ${props => {
    if (props.disabled) return `cursor: text;`;
  }}
`;

export const Divider = styled.div`
  width: 100%;
  height: 0px;
  border: 1px solid ${props => props.color || "#000"};
  margin: ${props => props.margin};
`;

export const CircleNumber = styled.div`
  width: ${props => props.width || "4.8rem"};
  height: ${props => props.height || props.width || "4.8rem"};
  background-color: ${props =>
    props.bgColor || props.theme.colors.primary.green};
  font-size: ${props => props.fontSize || "1.6rem"};
  font-weight: ${props => props.fontWeight || props.theme.fontWeight.bold};
  color: ${props => props.color || props.theme.colors.primary.white};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Card = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 12px #00000029;
  border-radius: 4px;
  opacity: 1;
`;

export const Clickable = styled.div`
  cursor: pointer;
`;
